module.exports = __webpack_public_path__ + "static/media/Showcase_05.67d93bd9.jpg";